import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";
import { UntypedFormGroup } from "@angular/forms";
import moment from "moment";

export class FilterFormValidator {
  private validationResult = new ValidationResult();

  getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  validate(filterForm: UntypedFormGroup): ValidationResult {
    const startDate = moment(filterForm.get("startDate").value, "DD/MM/YYYY");
    const endDate = moment(filterForm.get("endDate").value, "DD/MM/YYYY");

    if (!startDate.isValid()) {
      this.validationResult.addErrorMessage("Data de início inválida.");
    } else if (!endDate.isValid()) {
      this.validationResult.addErrorMessage("Data final inválida.");
    } else if (startDate > endDate) {
      this.validationResult.addErrorMessage("Data inicial maior que data final.");
    }

    return this.validationResult;
  }
}
